"use client";

import { FC, ReactNode } from "react";

import { AppProgressBar as ProgressBar } from "next-nprogress-bar";

// ------------------------------------------------------------------------------------

export type IProgressBarProviderProps = {
  children: ReactNode;
};

const ProgressBarProvider: FC<IProgressBarProviderProps> = (props) => {
  const { children } = props;

  return (
    <>
      <ProgressBar
        height="3px"
        color="#054ADA"
        options={{ showSpinner: false }}
        shallowRouting
      />

      {children}
    </>
  );
};

export default ProgressBarProvider;
